<script setup lang="ts">
import { useScenarioChatPageQuery } from './ScenarioChatPage.generated'
import { useRoute } from 'vue-router'
import ScenarioChatPageInner from './ScenarioChatPageInner.vue'

const route = useRoute('scenarioChatEdit')
const scenarioChatGuid = route.params.guid

const pageQuery = useScenarioChatPageQuery(
  {
    guid: scenarioChatGuid,
  },
  {
    fetchPolicy: 'no-cache',
  }
)
</script>

<template>
  <ScenarioChatPageInner
    v-if="pageQuery.result.value"
    :initial-scenario-chat="pageQuery.result.value.scenarioChat.scenarioChat"
    :query="pageQuery.result.value"
  />
</template>
